<template>
<!-- 按货位盘点 -->
  <div>
    <!-- 基础信息 S -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="color:#222;font-weight:600">基础信息</span>
        <el-tooltip class="item" effect="dark" style="float: right; padding: 3px 0;color:#969696;font-size:14px" placement="bottom-start">
          <div slot="content">按商品总数盘点：盘点商品在仓库的总数量(效期商品按日期盘点)；<br>按商品货位盘点：盘点商品在指定库区中的数量；<br>按货位盘点：盘点货位上每种商品的数量。<br>
          </div>
          <span>盘点类型说明 <i class="el-icon-warning-outline"></i></span>
        </el-tooltip>
      </div>
      <el-form :inline="true" :model="planFrom" class="demo-form-inline" label-width="160px">
        <el-form-item label="盘点类型：" required>
          <span v-if="type==1">按商品总数盘点</span>
          <span v-else>按商品货位盘点</span>
        </el-form-item>
         <el-form-item label="供应商：" required>
          <el-select v-model="planFrom.supplierCode" filterable @change="changeSupplier">
            <el-option v-for="(item,index) in supplierSelects" :key="index"  :label="item.name" :value="item.code"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="盘点库区：" required v-if="type==0">
          <el-select v-model="planFrom.yaId" placeholder="请选择">
            <el-option v-for="(item,index) in reservoirAreaList" :key="index" :label="item.yaName" :value="item.yaId"></el-option>
          </el-select>
          <div style="color:#888">盘点时，只盘选中商品在该库区的库存</div>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 基础信息 E -->
    <!-- 盘点明细 S -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="color:#222;font-weight:600">盘点明细</span>
      </div>
      <el-button type="primary" @click="add">+新增商品</el-button>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="ygName" label="商品名称" min-width="100" ></el-table-column>
        <el-table-column prop="bdName" label="商品属性"  min-width="100" align="center"></el-table-column>
        <el-table-column prop="standard" label="规格" min-width="100" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.standard">-</span>
            <span v-else>{{scope.row.standard}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="box" label="箱规（件/箱）"  min-width="100" align="center"></el-table-column>
        <el-table-column prop="goodsCode" label="商品编码" min-width="100" align="center"></el-table-column>
        <el-table-column prop="barCode" label="商品条码"  min-width="100" align="center">
           <template slot-scope="scope">
            <span v-if="!scope.row.barCode">-</span>
            <span v-else>{{scope.row.barCode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click.native.prevent="deleteRow(scope.$index, tableData)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="submit-btn">
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-card>
    <!-- 盘点明细 E -->
    <!-- 弹窗 S -->
    <el-dialog title="新增商品" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
       <el-form :model="searchForm" label-width="10px">
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <el-input placeholder="请输入商品名称/编码/条码" v-model="searchForm.conditions"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
              <el-button @click="reset">重置</el-button>
            </el-form-item>
           </el-col>
         </el-row>
      </el-form>
      <page-table ref='pageTable'
                  :list="goodsLocationList"
                  :fieldList="tableFieldList"
                  :selection="true"
                  deleteName="id"
                  :reserveSelection="true"
                  :selectable="selectable"
                  rowKey="goodsCode">
        <template v-slot:col-inventory="scope">
          <div>{{scope.row.inventory}}{{ scope.row.minUnit }}</div>
          ({{ Math.floor(scope.row.inventory / scope.row.box) }}{{ scope.row.maxUnit }}{{ scope.row.inventory % scope.row.box }}{{ scope.row.minUnit }})
        </template>
        <template v-slot:col-unavailable="scope">
          <div>{{scope.row.unavailable}}{{ scope.row.minUnit }}</div>
          ({{ Math.floor(scope.row.unavailable / scope.row.box) }}{{ scope.row.maxUnit }}{{ scope.row.unavailable % scope.row.box }}{{ scope.row.minUnit }})
        </template>
      </page-table>
      <span slot="footer" class="dialog-footer">
        <div style="color:#969696;font-size:14px;text-align:left;margin-bottom:8px">已选、盘点单未完成，或盘点损益未处理的商品不可重复盘点。</div>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗 E -->
  </div>
</template>
<script>
import liquidationManage from '@/store/liquidationManage/index'
import { GETLOCATIONGOODSDETAIL, SAVELIQUIDATIONPLAN, CHECKTASK } from '@/store/liquidationManage/types'
import { GETRESERVOIRAREALIST } from '@/store/reservoirAreaManage/types.js'
import reservoirAreaManage from '@/store/reservoirAreaManage/index'
import assignmentManage from '@/store/assignmentManage/index'
import { SUPPLIERGETLISTDATA } from '@/store/assignmentManage/types'
import pageTable from '@/components/Table/Index'
import { CLOSECURRENTTAG } from '@/store/user/types'
let _self
export default{
  components: {
    pageTable
  },
  name: 'addPlanGoods',
  data () {
    return {
      planFrom: {},
      tableData: [], // 货位列表
      multipleSelection: [], // 选中信息
      dialogVisible: false,
      searchForm: {
        conditions: null
      },
      type: null,
      disableGoodsCode: [], // 禁用的商品编码
      currentSelect: null,
      warehouseCode: ''
    }
  },
  computed: {
    // 商品信息
    goodsLocationList () {
      return {rows: liquidationManage.state.goodsLocationList}
    },
    // 库区
    reservoirAreaList () {
      return reservoirAreaManage.state.reservoirAreaList.rows
    },
    // 下拉框 - 供应商
    supplierSelects () {
      return assignmentManage.state.supplierSelects
    },
    tableFieldList () {
      return [
        { label: '商品名称', prop: 'ygName', width: 150, align: 'center' },
        { label: '商品属性', prop: 'bdName', width: 150, align: 'center' },
        { label: '规格', prop: 'standard', width: 150, align: 'center' },
        { label: '箱规（件/箱）', prop: 'box', width: 150, align: 'center' },
        { label: '可用库存', prop: 'inventory', width: 150, type: 'slot', align: 'center' },
        { label: '不可用库存', prop: 'unavailable', width: 150, type: 'slot', align: 'center' },
        { label: '商品编码', prop: 'goodsCode', width: 150, align: 'center' },
        { label: '商品条码', prop: 'barCode', width: 150, align: 'center' }
      ]
    },
    pageTable () {
      return this.$refs.pageTable.$refs.table
    },
    addPlanMark () {
      return liquidationManage.state.addPlanMark
    },
    planSave () {
      return liquidationManage.state.planSave
    }
  },
  watch: {
    addPlanMark (newVal) {
      if (newVal === 1) {
        liquidationManage.state.addPlanMark = 0
        this.$store.dispatch(CLOSECURRENTTAG, '/liquidationManage/liquidationPlan')
      }
    },
    planSave (newVal) {
      if (newVal.code === 503) {
        let arr = []
        let arrName = []
        newVal.list.forEach(item => {
          arr.push(item.yitaGoodsCode)
          arrName.push(item.goodsName)
          this.disableGoodsCode.push(item.yitaGoodsCode)
        })
        this.$confirm(arrName.join('、') + '已在盘点或损益未处理，不可重复盘点。', '提示', {
          confirmButtonText: '删除问题商品并保存',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          for (var i = 0; i < this.tableData.length; i++) {
            if (arr.indexOf(this.tableData[i].goodsCode) > -1) {
              this.tableData.splice(i, 1)
              i = i - 1
            }
          }
          liquidationManage.state.planSave = {}
          this.save()
        }).catch(() => {
          liquidationManage.state.planSave = {}
        })
      } else if (newVal.code === 502) {
        this.$message({
          message: newVal.describe,
          type: 'warning'
        })
        liquidationManage.state.planSave = {}
      }
    },
    $route (to, from) {
      this.type = this.$route.params.type
      this.warehouseCode = this.$route.params.warehouseCode
      this.getReservoirAreaList()
      this.$store.dispatch(SUPPLIERGETLISTDATA, { warehouseCode: this.warehouseCode })
    }
  },
  mounted () {
    _self = this
    this.type = this.$route.params.type
    this.warehouseCode = this.$route.params.warehouseCode
    this.getReservoirAreaList()
    this.$store.dispatch(SUPPLIERGETLISTDATA, { warehouseCode: this.warehouseCode })
  },
  methods: {
    // 新增货位
    add () {
      if (!this.planFrom.supplierCode) {
        this.$confirm('请选择供应商！', '提示', {
          confirmButtonText: '知道了',
          type: 'warning',
          showCancelButton: false
        })
        return
      }
      if (!this.planFrom.yaId && this.type === 0) {
        this.$confirm('请选择盘点库区！', '提示', {
          confirmButtonText: '知道了',
          type: 'warning',
          showCancelButton: false
        })
        return
      }
      this.search()
      this.dialogVisible = true
      this.setSelection()
    },
    // 提交信息
    submit () {
      let goodCodes = []
      this.pageTable.selection.forEach(item => {
        goodCodes.push(item.goodsCode)
      })
      let params = {
        yipType: this.$route.params.type,
        yaId: this.planFrom.yaId,
        goodCodes: goodCodes.join(','),
        warehouseCode: this.warehouseCode
      }
      let list = new Promise((resolve, reject) => {
        _self.$store.dispatch(CHECKTASK, params).then(res => {
          if (res.obj && res.obj.code === 502) { // 已存在未完成的盘点单 不允许新增 关闭窗口
            this.$message({
              message: res.obj.describe,
              type: 'warning'
            })
          } else if (res.obj && res.obj.code === 503) { // 已存在未完成的盘点货位 不允许新增
            let arr = []
            let arrName = []
            res.obj.list.forEach(item => {
              arr.push(item.yitaGoodsCode)
              arrName.push(item.goodsName)
              this.disableGoodsCode.push(item.yitaGoodsCode)
            })

            this.$confirm(arrName.join('、') + '已在盘点或损益未处理，不可重复盘点。', '提示', {
              confirmButtonText: '删除问题商品并保存',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.tableData = [...this.pageTable.selection]
              this.pageTable.selection.forEach((item, index) => {
                if (arr.indexOf(item.goodsCode) > -1) {
                  delete this.tableData[index]
                }
              })
              for (var i = 0; i < this.tableData.length; i++) {
                if (!this.tableData[i]) {
                  this.tableData.splice(i, 1)
                  i = i - 1
                }
              }
              this.handleClose()
            }).catch(() => {})
          } else {
            if (this.pageTable.selection.length > 0) {
              let arrStr = JSON.stringify(this.tableData)
              this.pageTable.selection.forEach(item => {
                if (arrStr.indexOf(item.goodsCode) === -1) {
                  this.tableData.push(item)
                }
              })
            }
            this.handleClose()
          }
        })
      })
      console.log(list)
    },
    // 关闭窗口
    handleClose () {
      this.dialogVisible = false
      this.pageTable.clearSelection()
    },
    // 保存
    save () {
      if (!this.planFrom.supplierCode) {
        this.$confirm('请选择供应商！', '提示', {
          confirmButtonText: '知道了',
          type: 'warning',
          showCancelButton: false
        })
        return
      }
      if (!this.planFrom.yaId && this.type === '0') {
        this.$confirm('请选择盘点库区！', '提示', {
          confirmButtonText: '知道了',
          type: 'warning',
          showCancelButton: false
        })
        return
      }
      if (this.tableData.length === 0) {
        this.$message({
          message: '请添加商品！',
          type: 'warning'
        })
        return
      }
      let goodCodes = []
      this.tableData.forEach(item => {
        goodCodes.push(item.goodsCode)
      })

      let params = {
        yipType: this.$route.params.type,
        yaId: this.planFrom.yaId,
        supplierCode: this.planFrom.supplierCode,
        goodCodes: goodCodes.join(','),
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(SAVELIQUIDATIONPLAN, params)
    },
    // 搜索
    search () {
      if (this.dialogVisible) {
        this.pageTable.clearSelection()
        this.setSelection()
      }
      let params = {
        ysCode: this.planFrom.supplierCode,
        conditions: this.searchForm.conditions,
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(GETLOCATIONGOODSDETAIL, params)
    },
    // 重置
    reset () {
      this.searchForm = {
        ylCode: null,
        checked: true
      }
      this.search()
    },
    // 选择
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 获取库区下拉框
    getReservoirAreaList () {
      let params = {
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(GETRESERVOIRAREALIST, params)
    },
    // 删除
    deleteRow (index, rows) {
      rows.splice(index, 1)
    },
    // 设置禁止选择
    selectable ({goodsCode}) {
      let arr = []
      this.tableData.forEach(item => {
        arr.push(item.goodsCode)
      })
      if (arr.indexOf(goodsCode) > -1) {
        return false
      }
      return true
    },
    setSelection () {
      let arr = JSON.parse(JSON.stringify(this.tableData))
      this.$nextTick(() => {
        arr.forEach(item => {
          this.pageTable.toggleRowSelection(item)
        })
      })
    },
    changeSupplier (val) {
      if (this.tableData.length > 0) {
        this.$confirm('修改后，下方已选商品将清空，需重新添加，您确定修改吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData = []
          this.disableGoodsCode = []
          this.currentSelect = val
        }).catch(() => {
          this.planFrom.supplierCode = this.currentSelect
        })
      } else {
        this.currentSelect = val
      }
    }
  }
}
</script>
<style scoped>
 .submit-btn {
   margin:10px 20px 10px;
   float: right;
  }
</style>



// WEBPACK FOOTER //
// src/page/liquidationManage/addPlan/addPlanGoods.vue